import { SoccerIncidentId } from '@collector/sportsapi-client-legacy'

import { CustomIncidentNames } from '../../configuration'

export const customIncidentNames: CustomIncidentNames<SoccerIncidentId> =
  new Map([[SoccerIncidentId.SubstitutionIn, 'Substitution']])
